<template>
  <div>
    <DocumentPdf
      v-if="pdfUrl && pdfUrl.trim() !== ''"
      :pdfUrl="pdfUrl"
      @pdf-load-success="handlePdfLoadSuccess"
      @pdf-load-error="handlePdfLoadError"
    />
    <div v-else class="text-center text-secondary my-2 align-items-center">
        <b-spinner class="align-middle me-2"></b-spinner>
        <strong>Esperando enlace del documento...</strong>
    </div>
    <div v-if="succesfullPdfLoad" class="text-center mt-3 mx-3 shadow-sm mb-2 p-2 rounded">
      <b-form-checkbox
        :checked="modelValue"
        @change="handleChange"
        class="me-2"
      >
        <span class="fw-bold h6 ms-2 fs-5">He leído el documento</span>
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import DocumentPdf from '@/components/shared/Document-pdf.vue';

export default {
  name: 'StatementDocumentViewer',

  components: {
    DocumentPdf
  },

  data() {
    return {
      pdfLoadStatus: 'pending' // 'pending', 'success', 'error'
    };
  },

  computed: {
    succesfullPdfLoad() {
      return this.pdfLoadStatus === 'success';
    }
  },

  props: {
    pdfUrl: {
      type: String,
      required: true
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  
  methods: {
    handleChange(newValue) {
      this.$emit('update:modelValue', newValue);
    },
    handlePdfLoadSuccess() {
      this.pdfLoadStatus = 'success';
    },

    handlePdfLoadError() {
      this.pdfLoadStatus = 'error';
    }
  },
  watch: {
    pdfUrl(newUrl, oldUrl) {
      if (newUrl !== oldUrl) {
        this.pdfLoadStatus = 'pending';
      }
    }
  }
}
</script>